import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import FormButtons from './formButtons'

// const mapDispatchToProps = dispatch =>
//   bindActionCreators(actions, dispatch)

export default connect(
  // mapDispatchToProps
)(FormButtons);
